import { isHttpUrl } from "@/utils/link";

/** 新しいタブを開けなかった（ポップアップがブロックされた）ことを表す。 */
export class DownloadPopupBlockedError extends Error {
  constructor() {
    super("Popup blocked");
    this.name = "DownloadPopupBlockedError";
  }
}

/**
 * 署名付きURLを新しいタブで開いてダウンロードする。
 * 署名URLの先で 403・期限切れ・ストレージ障害が起きても、エラー応答は新しいタブに表示され、
 * 元の画面（検索結果・詳細）を離れない。成功時は BE が付ける Content-Disposition: attachment により
 * 保存だけが行われる。
 * @param resolveUrl 押下時に署名付きURLを発行する関数
 * @returns 新しいタブへの遷移を開始したら解決。タブを開けない（ポップアップのブロック）場合は
 * DownloadPopupBlockedError、URLが無い・安全でない場合は Error で reject（開いたタブは閉じる）
 */
export const downloadInNewTab = async (
  resolveUrl: () => Promise<string | null | undefined>
): Promise<void> => {
  // URL発行の非同期処理の後に開くとポップアップとしてブロックされるため、押下直後に空のタブを開く。
  const tab = window.open("", "_blank");
  // 元の画面を離れないことが目的のため、タブを開けない場合は現在のタブへ遷移せず失敗として通知する。
  if (!tab) throw new DownloadPopupBlockedError();
  tab.opener = null;
  try {
    const url = await resolveUrl();
    if (!url || !isHttpUrl(url)) throw new Error("Download unavailable");
    tab.location.href = url;
  } catch (error) {
    tab.close();
    throw error;
  }
};
